<template>
    <div class="device-mobile"
        :style="{ background: 'default' == pageSetting.backgroundType ? '#fff' : pageSetting.background }">
        <layout :config="config.componentSetting" :showBreadcrumb>
            <slot></slot>
        </layout>
    </div>
</template>

<script setup>
import layout from './layout.vue';
import { useHomePageStore } from '~/store/homePage';

const props = defineProps({
    data: {
        type: Object,
        default: () => ({})
    },
    showBreadcrumb: {
        type: Boolean,
        default: true
    }
});

const homePageStore = useHomePageStore();
const config = computed(() => JSON.parse(props.data?.content || JSON.stringify({ componentSetting: [], pageSetting: {} })));
const pageSetting = config.value.pageSetting;

homePageStore.setPageSetting(pageSetting);
</script>

<style lang="scss" scoped></style>
